/**
 *  @class
 *  @function ArticleNavigation
 */
if (!customElements.get('article-navigation')) {
  class ArticleNavigation extends HTMLElement {
    constructor() {
      super();
      this._onScroll = null;
      this._rafId = null;
      this._isSticky = false;
    }
    connectedCallback() {
      requestAnimationFrame(() => {
        this.progress_bar = document.getElementById('progress-bar');
        this.article_element = document.getElementById('main-article');
        this.title_element = document.getElementById('post-title-wrapper');

        if (!this.article_element || !this.title_element) return;

        this.cacheOffsets();

        this._onScroll = () => {
          if (!this._rafId) {
            this._rafId = requestAnimationFrame(() => {
              this._rafId = null;
              this.onScroll();
            });
          }
        };

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', () => this.cacheOffsets());
        this.onScroll();
      });
    }
    disconnectedCallback() {
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
      }
      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
    }
    cacheOffsets() {
      let scrollY = window.scrollY;
      this._titleEnd = this.title_element.getBoundingClientRect().top + scrollY + this.title_element.offsetHeight;
      this._articleTop = this.article_element.getBoundingClientRect().top + scrollY;
      this._articleEnd = this._articleTop + this.article_element.offsetHeight;
      this._headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    }
    onScroll() {
      let scrollY = window.scrollY;

      // Progress bar
      let pixelScrolled = scrollY - this._articleTop - this._titleEnd + this._headerHeight;
      let progress = Math.max(pixelScrolled / this.article_element.offsetHeight, 0);
      this.progress_bar.style.transform = 'scale(' + progress + ', 1)';

      // Sticky toggle
      let shouldStick = scrollY > this._titleEnd && scrollY <= this._articleEnd;
      if (shouldStick !== this._isSticky) {
        this._isSticky = shouldStick;
        this.classList.toggle('navigation--sticky', shouldStick);
      }
    }
  }
  customElements.define('article-navigation', ArticleNavigation);
}
